import { useQuery } from '@tanstack/react-query';
import { useApiClient } from 'utils/apiClient';

// eslint-disable-next-line import/prefer-default-export
export const useReaders = () => {
  const apiClient = useApiClient();
  return useQuery({
    queryKey: ['shorepay', 'readers'],
    queryFn: apiClient.ShorePay.fetchReaders,
    select: (result) => result.data,
  });
};
